export default {
    init() {
      // Clients Say scripte 
      const allTestemonialsImg = document.querySelectorAll('.wp-post-image');
      const allTestemonialsVideo = document.querySelectorAll('.testimonial-video');
  
      if(allTestemonialsImg.length === 0) {
        return;
      }
      else {
        allTestemonialsImg.forEach((element, idx) => {
          element.addEventListener('click', (e) => {
            e.target.style.display = 'none';
            allTestemonialsVideo[idx].setAttribute('src', allTestemonialsVideo[idx].getAttribute('data-src'));
            allTestemonialsVideo[idx].style.display = 'block';
          })
        })
      }
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/ourResults.js